// icons
import { MdHearing } from "react-icons/md";

const disenadorAudifono = {
  id: 'disenador-audifono-group',
  type: 'group',
  roles: [1, 100, 110, 200],
  breadcrumbs: false,
  children: [
    {
      id: 'disenador-audifono',
      title: 'Diseñador de audífono',
      type: 'item',
      breadcrumbs: false,
      icon: MdHearing,
      url: '/disenador-de-audifono'
    }
  ]
};

export default disenadorAudifono;
